module.exports = __webpack_public_path__ + "static/flags/TH-b31881d6e7e4ccd676ef06f921fd9e06.gif";